import React, { memo } from "react";
import styles from "./ProductItem.module.scss";
import { SolarProduct } from "../../../../model/solar-product/solar-product";
import { useNavigate } from "react-router-dom";
import { ApplicationRoutes } from "../../../../routes";

type Props = {
	product: SolarProduct;
};

const ProductItem: React.FC<Props> = memo((props: Props) => {
	const { product } = props;
	const navigator = useNavigate();

	const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			navigator(`/${ApplicationRoutes.STORE_FRONT_ITEM}/${product.id}`);
		}
	};

	return (
		<div
			className={styles.container}
			onClick={() => navigator(`/${ApplicationRoutes.STORE_FRONT_ITEM}/${product.id}`)}
			onKeyDown={handleKeyDown}
			tabIndex={0}
			role="button"
		>
			<img src={product.images[0]?.imageUrl} alt="Product" />
			<div className={styles.productInfoContainer}>
				<div className={styles.productTitle}>{product.productName}</div>
				<div className={styles.productPrice}>₦{product.price.toLocaleString()}</div>
			</div>
		</div>
	);
});

export default ProductItem;
